import OSSAgreementContent from './oss-agreement-content.connect.js'

export default OSSAgreementContent
